import type { ReactNode } from 'react'
import { Label } from '@/components/shadcn/label'
import { cn } from '@/lib/utils'
import { HelpHint } from './HelpHint'

/**
 * A form label with its help trigger next to it.
 *
 * The hint is a sibling of the `<Label>`, never a child: a `<button>` inside a label that wraps
 * a checkbox would toggle that checkbox when clicked.
 */
export function HelpLabel({
  helpKey,
  children,
  className,
  labelClassName,
}: {
  helpKey: string
  children: ReactNode
  className?: string
  /** Passed through to the `<Label>` — used by checkbox rows, which lay the control out inside it. */
  labelClassName?: string
}) {
  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <Label className={labelClassName}>{children}</Label>
      <HelpHint helpKey={helpKey} />
    </div>
  )
}
